import { pushToGTM } from "@lib/gtmUtility"

const eventObj = {
    category: "",
    action: "",
    label: "",
    eventName: "",
}

const addEvent = ({ category, label, action, eventName }, eventData) => {
    eventObj.category = category
    eventObj.action = action
    eventObj.label = String(label)
    if (eventName) eventObj.eventName = eventName
    else eventObj.eventName = "newGAEvent"
    pushToGTM(eventObj, eventData)
}

export const resendOtpOnSmsGA = (category, label) => {
    addEvent({
        category,
        label,
        action: "Resend on SMS",
    })
}
export const resendOtpOnCallGA = (category, label) => {
    addEvent({
        category,
        label,
        action: "Resend on Call",
    })
}
export const resendOtpOnEmailGA = (category, label) => {
    addEvent({
        category,
        label,
        action: "Resend on Email",
    })
}
export const changeEmailGA = (category) => {
    addEvent({
        category,
        label: "Click",
        action: "Change Email",
    })
}
export const changeNumberGA = (category) => {
    addEvent({
        category,
        label: "Click",
        action: "Edit Number",
    })
}

// ---------- Events for phone flow start (including conflicts) --------------- //
export const onGetVerificationCodeGA = (label) => {
    addEvent({
        category: "Authentication",
        label: label,
        action: "Get Verification Code",
    })
}
export const onEnterOtpGA = (category, label) => {
    addEvent({
        category,
        label,
        action: "Continue",
    })
}
export const enterEmailNonConflictGA = (category, label) => {
    addEvent({
        category: `Enter Email id-${category}`,
        label,
        action: "Continue",
    })
}
export const knowMoreEmailConflictGA = () => {
    addEvent({
        category: "Choose an Email id-Conflict",
        label: "Click",
        action: "Know more",
    })
}
export const selectConflictingEmailGA = (label) => {
    addEvent({
        category: "Choose an Email id-Conflict",
        label,
        action: "Continue",
    })
}
export const addNewEmailConflictGA = () => {
    addEvent({
        category: "Choose an Email id-Conflict",
        label: "Click",
        action: "Enter new email id",
    })
}
export const enterNewEmailConflictGA = (label) => {
    addEvent({
        category: "Enter New Email id-Conflict",
        label,
        action: "Continue",
    })
}
export const verifyConflictingEmailGA = (label) => {
    addEvent({
        category: "Verify Existing Email id-Conflict",
        label,
        action: "Continue",
    })
}
export const signInWithEmailGA = () => {
    addEvent({
        category: "Authentication",
        label: "Click",
        action: "Signin with Email",
    })
}

// ---------- Events for phone flow end (including conflicts) --------------- //

// ---------- Events for email flow start (including conflicts) ------------- //

export const onEnterEmailOtpGA = (label) => {
    addEvent({
        category: "Verify Email id - login",
        label,
        action: "Continue",
    })
}
export const enterPhoneNumberForEmailFlowGA = (label) => {
    addEvent({
        category: "Enter mobile number - login",
        label,
        action: "Continue",
    })
}
export const verifyPhoneOtpGA = (label) => {
    addEvent({
        category: "Verify mobile number - login",
        label,
        action: "Continue",
    })
}
export const showMergePopupGA = () => {
    addEvent({
        category: "Enter mobile number - login",
        label: "Shown",
        action: "Phone number already registered with us",
    })
}
export const clickContinuePopupGA = () => {
    addEvent({
        category: "Enter mobile number - login",
        label: "Continue",
        action: "Merging phone number",
    })
}
export const mergeOtpGA = (label) => {
    addEvent({
        category: "Verify mobile number - login",
        label,
        action: "Verify OTP",
    })
}
export const knowMoreGA = () => {
    addEvent({
        category: "Enter mobile number - Conflict",
        label: "Click",
        action: "Know more",
    })
}
export const phoneConflictGA = (label) => {
    addEvent({
        category: "Enter mobile number - Conflict",
        label,
        action: "Continue",
    })
}
export const verifyPhoneOtpConflictGA = (label) => {
    addEvent({
        category: "Verify mobile number - Conflict",
        label,
        action: "Verify OTP",
    })
}

// ---------- Events for email flow end (including conflicts) --------------- //
